import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { usePapaParse } from "react-papaparse";
import { Chart, Axis, Tooltip, Coord, Legend, Interval } from "bizcharts";
import DataSet from "@antv/data-set";
import DownloadButton from "../Common/DownloadButton";

const HorizontalBarChartWIthNegative2 = (props) => {
  const [data, setData] = useState([]);
  const [max, setMax] = useState(20);
  const csv = props.csv;
  const filter = props.filter;
  const { readString } = usePapaParse();
  const [height, setHeight] = useState(500);

  const handleReadString = () => {
    readString(csv, {
      complete: (results, file) => {
        const filtered = results.data
          .filter((d) => d["Food commodity"] === filter)
          .map(d => ({
            ...d,
            "Difference% above LL 3 years ago": d["Difference% above LL 3 years ago"] || 0,
            "Difference% quantification 3 years ago": d["Difference% quantification 3 years ago"] || 0,
          }));
        setData(filtered);
        setHeight(filtered.length * 40 <= 120 ? 150 : filtered.length * 40);

        let tmpMax = 0;
        filtered.forEach((d, index) => {
          let exA = Math.abs(d["Difference% above LL 3 years ago"]);
          let exB = Math.abs(d["Difference% quantification 3 years ago"]);
          if (exA > tmpMax) {
            tmpMax = exA;
          }
          if (exB > tmpMax) {
            tmpMax = exB;
          }
        });
        setMax(tmpMax + 0.2);
      },
      download: true,
      header: true,
      dynamicTyping: true,
      error: (error, file) => {
        // console.log("Error while parsing:", error, file);
      },
    });
  };

  useEffect(() => {
    handleReadString();
  }, [filter]);

  const { DataView } = DataSet;
  const dv = new DataView();
  dv.source(data).transform({
    type: "fold",
    fields: [
      "Difference% above LL 3 years ago",
      "Difference% quantification 3 years ago",
    ],
    key: "opinion",
    value: "value",
  });

  const colorMap = {
    "Difference% above LL 3 years ago": "#688E31",
    "Difference% quantification 3 years ago": "#F9B112",
  };

  const [canvas, setCanvas] = useState(undefined);

  const getEmptyStateText = () => {
    return (
      "1 pesticide (" +
      data[0]["Pesticide"] +
      ") reported significant decrease in quantification (%) compared to 2019 (" +
      data[0]["Difference% quantification 3 years ago"] +
      "%)"
    );
  };

  data.forEach((item, index) => {
    const diffAboveLL = item["Difference% above LL 3 years ago"];
    const diffQuant = item["Difference% quantification 3 years ago"];



    // if (diffAboveLL === undefined || isNaN(diffAboveLL)) {
    //   console.warn(`Invalid "Difference% above LL 3 years ago" for item ${index}:`, item);
    //   item["Difference% above LL 3 years ago"] = 0;
    // }
    // if (diffQuant === undefined || isNaN(diffQuant)) {
    //   console.warn(`Invalid "Difference% quantification 3 years ago" for item ${index}:`, item);
    //   item["Difference% quantification 3 years ago"] = 0;
    // }

    item["Difference% above LL 3 years ago"] =
      Math.round(item["Difference% above LL 3 years ago"] * 100) / 100;
    item["Difference% quantification 3 years ago"] =
      Math.round(item["Difference% quantification 3 years ago"] * 100) / 100;
  });


  return (
    <Box>
      {data && data.length > 1 && (
        <Box>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <p
              style={{
                fontFamily: "Roboto Condensed, sans-serif",
                marginBottom: ".5rem",
              }}
            >
              {props.title}
            </p>
            <DownloadButton
              canvas={canvas}
              fileName={props.title}
              csv={data}
              isRaw
            />
          </Box>

          <Chart
            padding={[30, 20, 50, 250]}
            height={height}
            data={dv}
            autoFit
            scale={{
              value: {
                min: -(Math.ceil(max / 5) * 5),
                max: Math.ceil(max / 5) * 5,
              },
            }}
            onGetG2Instance={(chartInstance) => {
              setTimeout(() => {
                setCanvas(chartInstance.canvas);
              }, 1000);
            }}
          >
            <Axis
              name="Pesticide"
              title={null}
              labelOffset={10}
              label={{
                style: {
                  fontFamily: "Roboto Condensed, sans-serif",
                },
              }}
            />
            <Axis
              name="value"
              label={{
                formatter: (val) => {
                  return val + "%";
                },
                style: {
                  fontFamily: "Roboto Condensed, sans-serif",
                },
              }}
              tickLine={null}
              position="right"
            />
            <Coord transpose />
            <Tooltip
              shared
              itemTpl={
                '<li data-index={index} class="g2-tooltip-list-item" style="margin-bottom:3px;">' +
                '<span style="background-color:{color};width:10px;border-radius:50%;height:10px;display:inline-block;margin-right:8px;"></span>' +
                "{name}: {value} %" +
                "</li>"
              }
              containerTpl={
                '<div class="g2-tooltip"  id="tooltipWrap" >' +
                '<div class="g2-tooltip-title" id="tooltipTitle" style="font-weight:bold;font-size:medium;color:#22294d;">  </div>' +
                '<ul class="g2-tooltip-list " style="color:#22294d;"></ul>' +
                "</div>"
              }
            />
            <Legend flipPage={false} />
            <Interval
              position="Pesticide*value"
              color={[
                "opinion",
                function (opinion) {
                  return colorMap[opinion];
                },
              ]}
              shape="smooth"
              opacity={0.8}
              adjust={{
                type: "dodge",
              }}
            />
          </Chart>
        </Box>
      )}
      {data && data.length === 0 && (
        <Box display="flex" justifyContent="center">
          <p
            style={{
              color: "#22294D",
              fontWeight: "700",
              maxWidth: "280px",
              textAlign: "center",
              fontSize: "15px",
              backgroundColor: "white",
              border: "1px solid #22294D",
              borderRadius: "10px",
              padding: "10px 10px 10px 10px",
            }}
          >
            No significant differences reported for{" "}
            <span className="commoditySpan">{filter}</span> in all pesticides
            sampled
          </p>
        </Box>
      )}
      {data && data.length === 1 && (
        <Box display="flex" justifyContent="center">
          <p
            style={{
              color: "#22294D",
              fontWeight: "700",
              maxWidth: "280px",
              textAlign: "center",
              fontSize: "15px",
              backgroundColor: "white",
              border: "1px solid #22294D",
              borderRadius: "10px",
              padding: "10px 10px 10px 10px",
            }}
          >
            {getEmptyStateText()}
          </p>
        </Box>
      )}
    </Box>
  );
};

export default HorizontalBarChartWIthNegative2;
